import OnboardingPage from "./v3";

export function TeamsOnboarding() {
  return <OnboardingPage />;
}
